export const OVERVIEW_EXPORT_PAGE_SIZE = 2000;
export const OVERVIEW_EXPORT_MAX_ROWS = 50000;

export const fetchAllPagedItems = async ({
  requestPage,
  pageSize = OVERVIEW_EXPORT_PAGE_SIZE,
  maxRows = OVERVIEW_EXPORT_MAX_ROWS,
}) => {
  const items = [];
  let page = 1;
  let totalCount = Infinity;

  while (items.length < totalCount && items.length < maxRows) {
    const result = await requestPage(page, pageSize);
    const pageItems = result?.items || [];
    totalCount = Number.isFinite(result?.totalCount) ? result.totalCount : pageItems.length;
    items.push(...pageItems);

    if (pageItems.length === 0 || pageItems.length < pageSize) {
      break;
    }

    page += 1;
  }

  return {
    items,
    totalCount: Number.isFinite(totalCount) ? totalCount : items.length,
    truncated: items.length < totalCount && items.length >= maxRows,
  };
};
